import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpErrorResponse,
    HttpHandler,
    HttpEvent
} from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import { Auth } from 'aws-amplify';
import { from, throwError } from "rxjs";
import { Router } from '@angular/router';
import { TokenStorageService } from './shared/services/token.service';
@Injectable()
export class MyHttpInterceptor implements HttpInterceptor {
    constructor(public tokenStorage: TokenStorageService, private router: Router) { }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return from(this.handle(request, next)).pipe(catchError((err: HttpErrorResponse) => {
            if (err) {
                if (err.status === 401) {
                    console.log('this should print your error!', err.error);
                    // this.authRefresh();
                    // return next.handle(request);
                    this.reloadWindow();
                    return throwError(err);
                }
            }
        }));
    }
    // Custom refresh code
    reloadWindow() {
        // this.router.navigateByUrl(`/`).then(
            // () => { 
                console.log("@@router url:",this.router.url)
                this.router.navigateByUrl(this.router.url); 
            // });
    }
    // async authRefresh() {
    //     let session = await Auth.currentSession();
    //     var idTokenExpire = session.getIdToken().getExpiration();
    //     var refreshToken = session.getRefreshToken();
    //     Auth.currentAuthenticatedUser().then((res) => {
    //         res.refreshSession(refreshToken, (err, data) => {
    //             if (err) {
    //                 console.log("@@error console:", err);
    //                 Auth.signOut();
    //                 this.tokenStorage.signOut();
    //             } else {
    //                 console.log("@@In else block on interceptor:", data.getIdToken().getJwtToken());
    //                 this.tokenStorage.saveRefreshToken(refreshToken);
    //                 this.tokenStorage.saveToken(data.getIdToken().getJwtToken())
    //             }
    //         });
    //     });
    // }
    async handle(req: HttpRequest<any>, next: HttpHandler) {
        let session = await Auth.currentSession();
        var idTokenExpire = this.tokenStorage.getExpiryToken();
        var refreshToken = session.getRefreshToken();
        // console.log("@@refresh token:", refreshToken);
        var currentTimeSeconds = Math.round(+new Date() / 1000);
        console.log("@@idtokenexpire:", idTokenExpire, "@currentTimeSeconds:", currentTimeSeconds)
        if (idTokenExpire < currentTimeSeconds) {
            Auth.currentAuthenticatedUser().then((res) => {
                res.refreshSession(refreshToken, (err, data) => {
                    if (err) {
                        console.log("@@error console:", err);
                        Auth.signOut();
                        this.tokenStorage.signOut();
                    } else {
                        console.log("@@In else block on interceptor:", data.getIdToken().getJwtToken());
                        this.tokenStorage.saveRefreshToken(refreshToken);
                        this.tokenStorage.saveToken(data.getIdToken().getJwtToken())
                        this.tokenStorage.saveExpiryToken(data.getIdToken().getExpiration())
                    }
                });
            });
        }
        else {
            // console.log('@@came to idTokenExpire < currentTimeSeconds else block :',req)
        }
        return next.handle(req).toPromise();
    }
}
